import { useContext } from 'react';
import { PageContext } from '@/context/PageContext';
import { useTranslatableField } from './useTranslatableField';
import { determineHomepage, determineProjectPage, determineSafeUrl } from './determineUrls';

export const useExitRedirect = () => {
  const { survey, urlParams, project, linkHostname } = useContext(PageContext);
  const { translateField } = useTranslatableField(urlParams?.locale);

  let exitRedirect =
    translateField(survey?.configuration?.exit_redirect) ||
    determineProjectPage({
      domain: urlParams?.organization,
      locale: urlParams?.locale,
      project: project?.slug,
      projectHubEnabled: project?.projectHubEnabled,
      canonicalHostname: linkHostname,
    }) ||
    determineHomepage(urlParams?.organization || '', urlParams?.locale || '', linkHostname);

  // this should never be null as it is only has fallback values for 404 page which does not have env vars which does not require exit redirect.
  exitRedirect = exitRedirect ? determineSafeUrl(exitRedirect) : '#';

  return exitRedirect;
};
